<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div class="lf-repository-browser-header">
  <lf-breadcrumbs-component [breadcrumbs]="breadcrumbs" (breadcrumbClicked)="onBreadcrumbClicked($event)">
  </lf-breadcrumbs-component>
</div>
<div class="lf-repo-entry-container" [attr.tabindex]="isLoading || shouldShowErrorMessage || shouldShowEmptyMessage ? 0 : -1">
  <lf-loader-component *ngIf="isLoading" class="lf-text-body lf-no-user-select"></lf-loader-component>
  <div id="message-display" *ngIf="!isLoading && (shouldShowErrorMessage || shouldShowEmptyMessage)">
    <div *ngIf="shouldShowErrorMessage" class="lf-text-body lf-text-error lf-no-user-select">{{ AN_ERROR_OCCURED | async }}</div>
    <div *ngIf="shouldShowEmptyMessage" class="lf-text-body lf-no-user-select">{{ THIS_FOLDER_IS_EMPTY | async }}</div>
  </div>

  <lf-selection-list-component
    [hidden]="isLoading || shouldShowErrorMessage || shouldShowEmptyMessage"
    [uniqueIdentifier]="repoBrowserUniqueId"
    [listItems]="currentFolderChildren"
    [multipleSelection]="multiple"
    [itemSize]="item_size"
    [pageSize]="page_size"
    (scrollChanged)="onScroll()"
    [listItemRef]="listOption"
    (itemDoubleClicked)="onDblClickAsync($event)"
    (itemSelected)="onItemSelected($event)"
    (itemFocused)="onEntryFocused($event)"
    (refreshData)="refreshAsync(false)"
  >
    <ng-template #listOption let-item="value">
      <div *ngIf="getIcons(item).length > 0" class="fixed-size-icon-container  lf-no-user-select">
        <img *ngFor="let icon of getIcons(item)" src="{{ icon }}" alt="" class="lf-entry-icon" />
      </div>
      <div title="{{ item?.name }}" class="lf-ellipsis-label lf-no-user-select">{{ item?.name }}</div>
    </ng-template>
  </lf-selection-list-component>
</div>
